<template lang="pug">
    #task.right-panel.md-elevation-1.md-scrollbar.md-theme-default
        #deal-form.entity-card
            .md-layout.md-gutter.entity-card-head
                .md-layout-item.entity-head-left.md-layout.md-gutter
                    .md-layout-item.md-size-33
                        md-field(v-bind:class="{ 'md-invalid': errors.has('deadline'), 'md-has-value': task.deadline  }")
                            datetime(
                                name="deadline"
                                v-validate=""
                                v-model="task.deadline"
                                input-class="md-input"
                                type="datetime"
                                v-bind:use12-hour="false"
                                v-bind:week-start="1"
                                v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }"
                            )
                            span.md-error(v-show="errors.has('deadline')") {{ errors.first('deadline') }}

                    .md-layout-item.md-size-33    
                        md-field(v-bind:class="{ 'md-invalid': errors.has('project_id') }" v-if="projects && projects.length")
                            md-select(v-model="task.project_id" name="project_id"  v-validate="'required'")
                                md-option(v-for="project in projects" v-bind:value="project.id" v-bind:key="project.id") {{project.name}}

                    .md-layout-item.md-size-33
                        md-field(v-bind:class="{ 'md-invalid': errors.has('status_id') }" v-if="statuses && statuses.length")
                            //label(for="status_id") Статус
                            md-select(id="status_id" v-model="task.status_id" name="status_id"  v-validate="'required'")
                                md-option(v-for="status in statuses" v-bind:value="status.id" v-bind:key="status.id") {{status.name}}
                
                .md-layout-item.entity-head-right
                    md-button.md-primary.md-icon-button.md-dense.close.small(v-on:click="save")
                        md-icon check
                        md-tooltip(md-direction="bottom" md-delay="500") Сохранить
                    md-button.md-icon-button.md-dense.close.small(v-bind:to="{name: 'Tasks'}")
                        md-icon close
                        md-tooltip(md-direction="bottom" md-delay="500") Отменить

            .entity-card-body(v-loader-overlay="progress")
                .body-head-container
                    .taskmaster(v-if="task.taskmaster")
                        span Созданна {{moment(task.created_at).calendar() + ' (' + (task.taskmaster.fio ? task.taskmaster.fio : task.taskmaster.login ) + ')'}}
                    .waste-time(v-if="wasteTime"): b {{wasteTime.days + 'дн, ' + wasteTime.hours + 'ч, ' + wasteTime.days + 'мин'}}
                .md-layout.md-gutter
                    .md-layout-item.md-size-50
                        autocomplete(
                            placeholder="Ответственый"
                            label="Ответственый*"
                            display-property="fio"
                            property="fio"
                            return="id"
                            v-model="task.responsible_id"
                            v-bind:showOnFocus="true"
                            v-bind:callback="suggestResponsible"
                            v-bind:items="responsibles" 
                            v-bind:default="(task && task.responsible) ? (task.responsible.fio) ? task.responsible.fio : task.responsible.login  : ''"
                            v-on:select="selectResponsible"
                            :required="true"
                            id="responsible"
                            name="responsible"
                        )
                    .md-layout-item.md-size-50
                        multy-autocomplete(
                            placeholder="Исполнители"
                            label="Исполнители"
                            display-property="fio"
                            property="fio"
                            return="id"
                            v-model="task.coexecutor"
                            v-bind:showOnFocus="true"
                            v-bind:callback="suggestResponsible" 
                            v-on:select="selectResponsible"
                            id="coexecutor"
                            name="coexecutor"
                        )
                
                multy-autocomplete(
                    ref="groups"
                    placeholder="Теги"
                    label="Теги"
                    display-property="name"
                    property="name"
                    return="id"
                    v-model="task.groups"
                    v-bind:showOnFocus="true"
                    v-bind:items="groups"
                    v-bind:show-search-input="false"
                    v-on:select="selectGroup"
                    v-bind:can-add="true"
                    id="groups"
                    name="groups"
                    v-validate="''"
                    v-bind:error="errors.first('groups')"
                    data-vv-name="groups"
                    v-bind:data-vv-as="' '"
                )
                    z-input(
                        name="group_name" id="group_name" label="Название" v-model="newGroup.name" 
                        v-validate="'min:3|max:50'" v-bind:error="errors.first('group.group_name')"
                        data-vv-name="group_name"
                        v-bind:data-vv-as="' '"
                        data-vv-scope="contact"
                    )
                    md-button.md-primary.md-dense(v-on:click="saveGroup") Сохранить

                z-input(
                    name="name" 
                    id="name" 
                    label="Название задачи" 
                    v-model="task.name" 
                    v-bind:error="errors.first('name')"
                    v-validate="'required|min:4|max:255'"
                    data-vv-as=" "
                    data-vv-name="name"
                )
                
                z-markdown(
                    name="description" 
                    id="description" 
                    label="Описание" 
                    v-model="task.description" 
                    v-bind:error="errors.first('description')"
                    v-validate="'min:4|max:255'"
                    data-vv-as=" "
                    data-vv-name="description"
                )

                flex-tabs(v-bind:tabs="tabs" v-model="activeTab")
                z-task-checklist(label="Добавить чек-лист" v-model="task.checklist" v-show="(activeTab == 'tab-check')")
                z-task-time(v-if="task.id && task.id != 'new' && user && user.id" v-bind:task-id="task.id" v-bind:user-id="user.id" v-bind:user="user" v-show="(activeTab == 'tab-timeline')")
                comments-and-logs( v-if="task.id && task.id != 'new'" :entity_id="task.id" entity="task" module="tasks" v-show="(activeTab == 'tab-comments')")
</template>
<script>
import moment from "moment";
import EditArea from '@/components/EditArea';
import comments from '@/components/comments';
import logs from '@/components/logs';
import autocomplete from '@/components/autocomplete';
import MultyAutocomplete from '@/components/MultyAutocomplete';
import ZColorSelector from '@/components/ZColorSelector';
import ZInput from '@/components/ZInput';
import ZMarkdown from '@/components/ZMarkdown';
import ZTaskChecklist from '@/components/ZTaskChecklist';
import ZTaskTime from '@/components/ZTaskTime';
import ZSelect     from '@/components/ZSelect.vue';
import commentsAndLogs from '@/components/CommentsAndLogs'
import FlexTabs     from '@/components/FlexTabs';
export default {
    components: {
        ZInput, ZMarkdown, ZTaskChecklist, ZTaskTime, EditArea, comments, logs, autocomplete, MultyAutocomplete, commentsAndLogs, FlexTabs, ZColorSelector, ZSelect
    },
    data() {
        return {
            title: 'Задача',
            loading: false,
            responsibles: [],
            projects: [],
            statuses: [],
            groups: [],
            newGroup: {
                id: null,
                name: '',
                description: '',
                sort: 100,
            },
            testColor: null,
            newGroupDefault: {
                id: null,
                name: '',
                description: '',
                sort: 100,
            },
            activeTab: 'tab-check',
            tabs: [
                {name: "tab-check",    label: "Чек лист", error: false},
                {name: "tab-timeline", label: "Время",    error: false},
                {name: "tab-comments", label: "История",  error: false}
            ],
            task: {
                id:  null,
                name: '',
                description:    '',
                taskmaster_id:  null,
                responsible_id: null,
                project_id: null,
                deadline:   null,
                sort: 100,
                status:    null,
                status_id: null,
                parent_task_id: null,
                type: 1,
                time_start:  null,
                time_finish: null,
                wasted_time: null,
                timeline_id: null,
                deal_id:     null,
                time: {
                    wasted_time: 0,
                    time_list: []
                },
                taskmaster:  null,
                responsible: null,
                project:     null,
                status_section: null,
                deal: null,
                groups: [],
                coexecutor: [],
                child_tasks: [],
                checklist: []
            },
            taskDefault: {
                id:  null,
                name: '',
                description:    '',
                taskmaster_id:  null,
                responsible_id: null,
                project_id: null,
                deadline:   null,
                sort: 100,
                status:    null,
                status_id: null,
                parent_task_id: null,
                type: 1,
                time_start:  null,
                time_finish: null,
                wasted_time: null,
                timeline_id: null,
                deal_id:     null,
                time: {
                    wasted_time: 0,
                    time_list: []
                },
                taskmaster:  null,
                responsible: null,
                project:     null,
                status_section: null,
                deal: null,
                groups: [],
                coexecutor: [],
                child_tasks: [],
                checklist: []
            }
        }
    },
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        id() {
            return this.$route.params.taskid;
        },
        progressObj() {
            return this.$store.state.progressObj;
        },
        progress() {
            return this.progressObj['load-task-card'];
        },
        user() {
            return this.$store.state.users.current;
        },
        wasteTime() {
            if (!this.task.id || !this.task.time || !this.task.time.wasted_time || parseInt(this.task.time.wasted_time) <= 0) return;
                let time = {minutes: 0, hours: 0, days: 0, minutes: 0};

                time.minutes = Math.floor(this.task.time.wasted_time);
                time.hours   = Math.floor(time.minutes/60);
                time.days    = Math.floor(time.hours/8);
                time.hours   = time.hours   - (time.days * 8);
                time.minutes = time.minutes - (time.hours * 60) - (time.days * 8 * 60);

            return time;
        }
    },
    watch: {
        'id'() {
            this.init();
        },
        'task.project_id'() {
            this.getStatuses();
        }
    },
    methods: {
        init(force) {
            this.$nextTick(() => {
                this.$store.commit('openRightPanel');
                
                this.task = Object.assign({}, this.taskDefault);
                if (this.id && this.id != 'new') this.getTask();
                else if (this.$route.params && this.$route.params.dealid) this.task.deal_id = this.$route.params.dealid;

                this.suggestResponsible();
                if (force) this.getProjects();
                this.getGroups();
            });
        },
        listeners() {
            this.$root.$on('update-task', task => {
                this.task = Object.assign({}, this.taskDefault);
                this.$nextTick(() => this.task = Object.assign({}, task));
            });
        },
        getTask() {
            this.$store.commit('showProgressBar', 'load-task-card');
            this.$store.dispatch('tasks/getTask', this.id).then(r => {
                if (r) {
                    this.task = Object.assign({}, r);
                    this.getStatuses();
                }
            }).finally(() => this.$store.commit('hideProgressBar', 'load-task-card'));
        },
        suggestResponsible(search) {
            let data = {
                page:       1,
                order_by:   'id',
                order_type: 'asc',
                count:      50,
                filter:     {model: [], relation: []}
            };
            
            if (search) {
                data.filter.model.push(['login', '%', search], 'or', ['fio', '%', search]);
            } else data.filter.relation.push(['groups', 'code', '=', 'managers']);

            return this.$store.dispatch('users/getUsers', data).then(r => {
                this.responsibles = Object.assign([], r);
                return r;
            });
        },
        selectResponsible(value, user) {},
        getProjects() {
            this.$store.commit('showProgressBar', 'load-task-card');
            return this.$store.dispatch('tasks/getProjects').then(r => {
                if (r && r.length) this.projects = Object.assign([], r);
            }).finally(() => this.$store.commit('hideProgressBar', 'load-task-card'));
        },
        getStatuses() {
            this.$store.commit('showProgressBar', 'load-task-card');
            this.$store.dispatch('tasks/getTaskStatuses', {project_id: this.task.project_id}).then(r => {
                if (r && r.length) this.statuses = Object.assign([], r);
            }).finally(() => this.$store.commit('hideProgressBar', 'load-task-card'));
        },
        getGroups(page, count, orderBy, orderType, filter) {
            let data = {
                order_by:   (orderBy)   ? orderBy    : 'id',
                order_type: (orderType) ? orderType : 'asc',
                filter:     (filter)    ? filter    : {model: [], relation: []}
            }
            this.$store.dispatch('tasks/getAllGroups', data).then(r => {
                if (r && r.length) this.groups = Object.assign([], r);
            });
        },
        saveGroup() {
            this.$validator.validateAll('group').then(valid => {
                if (!valid) return;
                this.$store.dispatch('tasks/addGroupNew', this.newGroup).then(group => {
                    this.groups.push(Object.assign({}, group));
                    this.newGroup = Object.assign({}, group);
                    setTimeout(() => { //Без setTimeout инпут this.$refs.contact не успевает обработать новый список КЛ и они начинают дублироваться
                        this.$refs.groups.selectItem(this.newGroup, true);    
                        this.$refs.groups.hideAddForm();
                        this.newGroup = Object.assign({}, this.newGroupDefault);
                    }, 0);
                    
                });
            });
        },
        selectGroup(group) {},
        save() {
            this.$validator.validateAll().then(valid => {
                if (!valid) return;
                this.$store.commit('showProgressBar', 'load-task-card');
                let data = Object.assign({}, {
                    name:           this.task.name,
                    description:    this.task.description,
                    taskmaster_id:  this.task.taskmaster_id,
                    responsible_id: this.task.responsible_id,
                    project_id:     this.task.project_id,
                    deadline:       this.task.deadline,
                    status_id:      this.task.status_id,
                    deal_id:        this.task.deal_id,
                    checklist:      this.task.checklist,
                    groups:         this.task.groups,
                    status: 1,
                    sort: 100,
                    type: 1,
                    coexecutor: []
                });
                if (this.id && this.id != 'new') data.id = this.id;
                if (this.task.coexecutor && this.task.coexecutor.length) this.task.coexecutor.map(user => {
                    data.coexecutor.push(user.id);
                });
                let action = (this.id && this.id != 'new') ? 'tasks/putTask' : 'tasks/postTask';
                this.$store.dispatch(action, data).then(r => {
                    //if (this.id && this.id != 'new') this.init();
                    //else this.$router.push({name: 'Task', query: this.$route.query, params: {taskid: r.id}});
                    if (!this.id || this.id == 'new') this.$router.push({name: 'Task', query: this.$route.query, params: {taskid: r.id}});
                }).finally(() => this.$store.commit('hideProgressBar', 'load-task-card'));
            });
        },
    },
    created() {
        this.$store.commit('openRightPanel');
        this.init(true);
        this.listeners();
    },
}
</script>
<style lang="sass"> 
    #task
        .entity-card
            .entity-card-head
                .entity-head-left
                    flex-shrink: 1
                .md-field
                    margin: 0 !important
                    padding: 0
                    min-height: auto
                    .md-input
                        height: 25px
                        line-height: 25px
                        font-size: 14px
            .body-head-container
                display: flex
                align-items: center
                justify-content: space-between
                margin: 0 0 10px 0
                .taskmaster
                .waste-time
                    span
                        margin: 0 5px 0 0
                    b

</style>



// WEBPACK FOOTER //
// Task.vue?6cf5df8b